import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const email = localStorage.getItem("elan_admin_email");
    const token = localStorage.getItem("elan_admin_token");
    return email && token ? { email, isTeacher: !!localStorage.getItem("elan_teacher_token") } : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verify = async () => {
      const token = localStorage.getItem("elan_admin_token");
      if (!token) { setLoading(false); return; }
      try {
        const { data } = await api.get("/auth/me");
        setUser({ email: data.email, isTeacher: !!data.isTeacher, restricted: !!data.restricted, teacherId: data.teacher_id, teacherName: data.teacher_name });
      } catch {
        localStorage.removeItem("elan_admin_token");
        localStorage.removeItem("elan_admin_email");
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    verify();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("elan_admin_token", data.access_token);
    localStorage.setItem("elan_admin_email", data.email);
    // Companion teacher token for seamless cross-portal navigation
    if (data.teacher_token) {
      localStorage.setItem("elan_teacher_token", data.teacher_token);
      localStorage.setItem("elan_teacher_email", data.email);
    } else {
      localStorage.removeItem("elan_teacher_token");
      localStorage.removeItem("elan_teacher_email");
    }
    setUser({ email: data.email, isTeacher: !!data.teacher_token, restricted: !!data.teacher_token, teacherId: data.teacher_id, teacherName: data.teacher_name });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("elan_admin_token");
    localStorage.removeItem("elan_admin_email");
    localStorage.removeItem("elan_teacher_token");
    localStorage.removeItem("elan_teacher_email");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
